import Title from '../components/title';
import Footer from '../components/footer';
import Subtitle from '../components/subtitle';
import Core from '../components/core';
import { ArrowLongDownIcon } from '@heroicons/react/20/solid'
import { ScrollRestoration } from "react-router-dom"

const navigation = [
    { id: 1, name: 'Nos recommandations', to: '/strategie-retraite/' , icon: ArrowLongDownIcon},
    { id: 2, name: 'Bilans retraite', to: '/bilan-retraite/' , icon: ArrowLongDownIcon},
    { id: 3, name: 'Articulation chômage / retraite', to: '/articulation-chomage-retraite/' , icon: ArrowLongDownIcon},
    { id: 4, name: 'Des solutions d\'optimisation', to: '/solutions-optimisation/' , icon: ArrowLongDownIcon},
    { id: 5, name: 'Etudes comparatives expatriation', to: '/retour-expatriation/' , icon: ArrowLongDownIcon},
    { id: 7, name: 'Liquidations de retraite', to: '/liquidations-retraite/' , icon: ArrowLongDownIcon},
]

const context = [
    {
        "title": <p className='text-lg leading-6 font-extrabold txt-oranges'>Module 1: Régime général de la Sécurité sociale et régime complémentaire AGIRC-ARRCO des salariés du secteur privé en France - grandes lignes du plan :</p>,
        "core": [
            {
                "subtitle": "",
                "text": ""
            }
        ]
    },
    {
        "title": <h3 className="text-lg font-semibold leading-6 text-gray-900"> Le régime général de la Sécurité sociale :</h3>,
        "core": [
            {
                "subtitle": "",
                "text": <span> La réforme des retraites </span>,
            },
            {
                "subtitle": "",
                "text": <span> Taux et assiettes des cotisations </span>,
            },
            {
                "subtitle": "",
                "text": <span> La formule de calcul de la pension </span>,
            },
        ]
    },
    {
        "title": <h3 className="text-lg font-semibold leading-6 text-gray-900"> Le régime complémentaire AGIRC-ARRCO :</h3>,
        "core": [
            {
                "subtitle": "",
                "text": <span> Taux et assiettes des cotisations </span>,
            },
            {
                "subtitle": "",
                "text": <span> La formule de calcul de la pension </span>,
            },
            {
                "subtitle": "",
                "text": <span> Coefficient d'anticipation </span>,
            },
        ]
    },
    {
        "title": <h3 className="text-lg font-semibold leading-6 text-gray-900"> Recommandations et points de vigilance</h3>,
        "core": [
            {
                "subtitle": "",
                "text": "",
            },
            {
                "subtitle": "",
                "text": "",
            },            
        ]
    },
    {
        "title": <p className='text-lg leading-6 font-extrabold txt-oranges'>Module 2: Articulation des carrières internationales dans le cadre de la législation française - grandes lignes du plan :</p>,
        "core": [
            {
                "subtitle": "",
                "text": ""
            }
        ]
    },
    {
        "title": <h3 className="text-lg font-semibold leading-6 text-gray-900"> Régime général de la Sécurité sociale - coordination des systèmes de retraite - principe de totalisation :</h3>,
        "core": [
            {
                "subtitle": "",
                "text": <span> Périodes d'activité salariée à l'étranger </span>,
            },
            {
                "subtitle": "",
                "text": <span> Conventions bilatérales de Sécurité sociale </span>,
            },
            {
                "subtitle": "",
                "text": <span> Exemples de totalisations </span>,
            },
        ]
    },
    {
        "title": <h3 className="text-lg font-semibold leading-6 text-gray-900"> Régime complémentaire AGIRC-ARRCO :</h3>,
        "core": [
            {
                "subtitle": "",
                "text": <span> Coefficient d'anticipation </span>,
            },
            {
                "subtitle": "",
                "text": <span> Cas concrets selon l'adhésion ou non à l'AGIRC-ARRCO international </span>,
            },            
        ]
    },
    {
        "title": <h3 className="text-lg font-semibold leading-6 text-gray-900"> Recommandations spécifiques aux carrières internationales</h3>,
        "core": [
            {
                "subtitle": "",
                "text": "",
            },
            {
                "subtitle": "",
                "text": "",
            },            
        ]
    },
]

export default function Conference () {
   

    return (
        <>
            <Title classNames="bg-conference bg-cover lg:bg-right bg-left" title="Nos conférences spécifiques" />

            <Subtitle subtitle="Découvrez nos conférences dédiées aux entreprises :" paragraph="Nous avons établit des conférences dans un souci de pédagogie et pour répondre à vos préoccupations. Nous proposons 2 modules de conférence adaptables selon les besoins de l'entreprise." />      

            <Core navigation={navigation} context={context} />

            <Footer />

            <ScrollRestoration />
        </>
    )
}